<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="bv-example-row mt-5">
        <Activation />
        <b-row class="">
            <b-col cols="3" class="desktop">
                <b-list-group>
                    <b-list-group-item @click="handleGeneral" :active="isGeneral" href="#">General</b-list-group-item>
                    <b-list-group-item @click="handleRefunds" :active="isRefunds" href="#">Refunds</b-list-group-item>
                    <b-list-group-item @click="handleLang" :active="isLanguage" href="#">Language</b-list-group-item>
                    <b-list-group-item @click="handleEvent" :active="isEvents" href="#">My Events</b-list-group-item>
                    <b-list-group-item @click="handleRecipe" :active="isRecipe" href="#">Recipes</b-list-group-item>
                    <b-list-group-item @click="handleInstructor" :active="isInstructor" href="#">Instructor</b-list-group-item>
                    <b-list-group-item @click="handleAccount" :active="isAccount" href="#">Account</b-list-group-item>
                    <b-list-group-item @click="handleSub" :active="isSubscription" href="#">Subscription</b-list-group-item>
                    <b-list-group-item @click="handlePayment" :active="isPayment" href="#">Payment</b-list-group-item>

                </b-list-group>
            </b-col>
            <b-col cols="12" md="9">
                <div class="accordion" role="tablist" v-if="isGeneral">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            What is Culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text><b>CultureSquare.com</b> is a pioneering platform that connects people to food, language, events, and shopping experiences hosted by cultures around the world. Here our curiosity of others is assuaged, our understanding heightened, and our humanity highlighted.</b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <!-- <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            Who Owns store.culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Culturesquare.com owns <a class="culture-primary" href="https://store.culturesquare.com" target="_blank">store.culturesquare.com</a> to run it store line of business. Store.culturesquare.com allows users to sell or purchase unique cultural items from around the world. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card> -->
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            What Makes Culture Square Unique?
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    <b>Culturesquare.com</b> is an unconventional online platform where your interest in other cultures and people’s way of life is embraced. We believe that during these interactions, a “human moment” is born. Here communities are healed, and connections are built for eternity. <br /> <br /> At Culturesquare.com our similarities and differences are celebrated. It does not matter your country of origin, your race, your language, views, foods, situations, careers, or background, what matters is the sharing of that piece of your identity with those willing to support you. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            Is Culture Square In My Country?
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>Though Culture Square operates globally, note that due to some local regulations and laws, Culture Square might not operate fully in certain countries or cities. Please, feel free to reach out to us at <span class="culture-primary">support@culturesquare.com</span> and we can provide you with a solid insight into how to become a CultureSquare.com representative in your country</b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            Can A Minor Be Invited Alone?
                        </b-card-header>
                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    No, all minors under 18 should be accompanied by an adult (Parents or Guardians). If events are for minors only, parental or guardian’s written consent or authorization should be provided and signed before the minor would be allowed to attend an online or in-person event.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            What Time Is Culture Square Open?
                        </b-card-header>
                        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Culturesquare.com operates 24 hours a day and 7 days a week, however, its support team is open Monday through Friday from 9 am to 8 pm Eastern time and Saturday to Sunday from 9 am to 9 pm Eastern time. A better way to reach us is through email: <span class="culture-primary">support@culturesquare.com</span> </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-7 header-tag="header" class="p-3" role="tab">
                            Who Is A Service Provider?
                        </b-card-header>
                        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    A Service Provider is someone or a company that provides services or solutions on-demand beyond the scope of free hosting. Their services may include but are not limited to teaching how to cook a traditional dish, selling traditional spices, providing language lessons, becoming a local guide etc. Most service providers list paid events and services. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-8 header-tag="header" class="p-3" role="tab">
                            What Is Free Hosting?
                        </b-card-header>
                        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Free Hosting is sharing of one’s own space and time to “freely” entertain an invited Guest or Guests without him or them requesting any extra services than what is benevolently provided by the Host. Note that a User can play both roles as a Service provider or as the Host. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-9 header-tag="header" class="p-3" role="tab">
                            Does Culturesquare.com Provide Insurance Coverage For Damages Or Theft By The Guest?
                        </b-card-header>
                        <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Culturesquare.com does not provide any coverage for damages caused by the Guest. Most of our guests are considered short-term guests. The guest is responsible for any damage and related costs incurred. However, check with your homeowner insurance provider to see what can be covered. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-10 header-tag="header" class="p-3" role="tab">
                            How To Return A Lost Item?
                        </b-card-header>
                        <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Call our support team at <span class="culture-primary">support@culturesquare.com</span> and a return label will be emailed to you. Please print that label and take the item to your nearest postal office to mail it back to our office. We will contact the owner of the lost item and mail it back. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-11 header-tag="header" class="p-3" role="tab">
                            Is Smoking And Alcohol Allowed At A Hosted Event?
                        </b-card-header>
                        <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    The decision to smoke or drink alcohol is up to the Host, and every Host is encouraged to post a very descriptive event post where all preferences about Guests are mentioned and thoroughly explained. Guests are discouraged from making assumptions. If you are not sure, please contact us at: <span class="culture-primary">support@culturesquare.com</span>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-12 header-tag="header" class="p-3" role="tab">
                            Can I Get Drunk While Attending A Culture Square Listed Event?
                        </b-card-header>
                        <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Getting drunk at an event is prohibited and can result in you being completely banned from using our platform and our app altogether. However, if there is alcohol and a lot of drink offered at an event by the Host, <span style="font-style: italic;"> PLEASE, DRINK RESPONSIBLY </span>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isRefunds">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            Can I Get A Refund After Booking An Event?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    It all depends on the host return policy. If you did initiate a cancellation within the allowable window, a full refund will be issued. Please always feel free to reach out to us@ <span class="culture-primary">support@culturesquare.com</span> if you are not sure about the cancellation window.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            How Can I Get My Refund After Returning An Item?
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Once we have determined that you are eligible for a refund, a credit will be effected on your credit or debit card. Note that it may take 5-7 business days for the credited amount to show on your bank statement.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isLanguage">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            What Is Bridging Language?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    A bridging language is the language that the course will be taught in. In other words the bridging language is the language that both the instructor and the students can speak fluently and communicate to one another while teaching or learning the course. <u> For example: a French speaking instructor who teaches English would speak French to French speaking students learning how to speak English. Thus, making French as the bridging language.</u>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            What are language options?
                        </b-card-header>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Culturesquare.com offers 4 exclusive options in language:
                                    <ul class="ml-5 font-weight-bold" style="list-style:auto">
                                        <li>The option to become a language instructor in any language</li>
                                        <li>The option to become a student in any language</li>
                                        <li>The option to run a global language club</li>
                                        <li>The option to become a member of a global language club run by natives</li>
                                    </ul>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            What Is A Language Club?
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    A language club is a place where language students from around the world can interact with native speakers and debate any social topic to improve fluency or stay fluent in their respective foreign language they want to master. Culturesquare.com Language Clubs make it easy to speak like a native and stay fluent for a lifetime. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            How To Create a Language Club?
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    As a native or fluent speaker of a language all you need to do is:
                                    <ul class="ml-5 mb-2 font-weight-bold" style="list-style:auto">
                                        <li>Create an account profile</li>
                                        <li>Click on language</li>
                                        <li>Click on create Language Club</li>
                                        <li>Pick the language you would want your club to speak or debate in</li>
                                        <li>Enter your club details and requirements</li>
                                        <li>Enter member preferences</li>
                                    </ul>
                                    Start admitting members. Note that you have the option to reject or approve members based on your club criteria. Depending on each club owners some clubs might request a fee to stay an active member on a daily, weekly, or monthly basis
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isInstructor">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            How To Become A Language Instructor?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Using our platform, from the dropdown, pick a language that you can teach to interested students around the world. Provide a short description of the language, who is eligible to join your class, your age, gender and nationality preferences, your fee and much more. Create a unique course profile, define the modules, and add course files. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            Can An Instructor Teach More Than One Language?
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Yes, an instructor can teach more than one language if they are proficient in all of the languages they teach and have credentials to back it up. Culture Square will investigate any claim of qualification to insure the integrity of the Platform </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isEvents">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            I’m Having Problem With Posting Or Creating My Event
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    If you are having a problem with creating or posting an event, please, make sure that the event picture you uploaded is in the right file (jpeg, jpg or png). Check the size of the picture and crop if necessary using site such as <a class="culture-primary" target="_blank" href="https://photoscissors.com">https://photoscissors.com</a> and select Shopify banner (1920 X1080). Download the picture to your computer and upload it to your post. If that does not work, please, log out and log back in. If these do not work, please, feel free to contact support at <span class="culture-primary">support@culturesquare.com.</span>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            My Post Does Not Show The Entire Picture.
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    You might need to resize the picture for it to fit the listing frame. We advise our users to use a site such as: <a class="culture-primary" target="_blank" href="https://photoscissors.com">https://photoscissors.com </a>to do so by selecting: Shopify (1920X1080). Download the resized picture to your computer and reupload it to your post. Note that to use extensive features may require you to subscribe.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            How To Create Events?
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    <ul class="ml-5 font-weight-bold" style="list-style:auto">
                                        <li>Click on event</li>
                                        <li>Select create event</li>
                                        <li>Filling in your event details </li>
                                        <li>Upload a photo for your event</li>
                                        <li>Post your event</li>
                                    </ul>
                                    Events can be created using our application process found on Culturesquare.com and can be hosted from anywhere around the world for free or as paid events depending on the event’s host. Though our primary goal and mission is to bridge cultural differences and encourage hospitability and kindness, we also provide a strong means where people and businesses can create wealth and generate income through our platform.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            What Are Event Clauses?
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Event clauses are guidelines that protect both the event hosts and guests attending from being liable of damages or loss. A host event post’s details will serve as clauses that would guide the guest as far as what to do and not do at event. Please, read the event post carefully to avoid any dispute. Clauses can be binding as a contract.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            How To Report an event Incident?
                        </b-card-header>
                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    You can reach the Culturesquare.com’ Support Team by completing the contact us form on the platform or by emailing us at <span class="culture-primary">support@culturesquare.com</span> . In order to conduct a thorough investigation and act accordingly, no complaints will be processed through a phone call. </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            Can I Sleepover After An Event?
                        </b-card-header>
                        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    It all depends on the Host and the nature of the event such as camping, night walking and cultural activities that may occur after midnight (Northern Lights, sports, Stay with Us Invitation), however, we encourage our Guest to pay attention to the details of the Event: time, duration and place to make sure that all preparations and precautions are taken into consideration.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isRecipe">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            How To Post A Recipe?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Once you are a registered user, posting a recipe will take less than 5 minutes. This is a better way to promote a special local dish, your restaurant menu, your products and events. Recipes are regularly updated on a daily, weekly and monthly basis, depending on the sponsor.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            What incentives Does Culturesquare.com offer for posting recipes?
                        </b-card-header>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    By posting your recipes regularly, you will highly stand a chance to be to showcase these recipes or be selected to cater private or public event or shows, which can result in quick scalability of your business.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            Can I order a recipe through Culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    We do not take orders for recipes listed on our website. However, each recipe has a “Find it here” button that will take you to where it could be ordered.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            Can I order a recipe through Culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-4" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    We do not take orders for recipes listed on our website. However, each recipe has a <b><span style="font-style:italics">“Find it here”</span></b> button that will take you to where it could be ordered.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            Can I Copy A Recipe Image And Content And Display It On A Personal Blog, Social Media Or Website?
                        </b-card-header>
                        <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    You are allowed to copy any recipe image and content as long as you link the content back to the Culturesquare.com original recipe post. All our contents including images are copyrighted and should not be distributed without its owner’s consent or permission. Linking back to the original post is viewed as recognizing the author copyright.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            How Can I Review A Recipe?
                        </b-card-header>
                        <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Click on review and you will be prompted to write a comment and rate the recipe. <b><span style="font-style:italics"> Note that you can only rate a recipe that you’ve ordered and tried.</span></b> All reviews are filtered, and a misleading review will be removed. Culturesquare.com does not allow outside links in its reviews. Putting outside links in your review will disqualify your post.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-7 header-tag="header" class="p-3" role="tab">
                            What Is The Easiest Way To Get Some Of The Recipes To An Events?
                        </b-card-header>
                        <b-collapse id="accordion-7" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    The simplest way to get some selected recipes to your event would be to subscribe to our exclusive event service here:<router-link class="culture-primary" to="/subscriptions">https://Culturesquare.com/subscriptions.</router-link> Pick a plan that matches your need. One of our consultants will reach out to you to get some specifics about your event, number of guests, location, date, time and provides you with a list of all recipes you would want to have your event.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-8 header-tag="header" class="p-3" role="tab">
                            Why Some Recipes Do Not Have Nutritional Information Such As Number Of Calories?
                        </b-card-header>
                        <b-collapse id="accordion-8" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Though Culturesquare.com is aware of a lots of computer programs that will calculate nutritional information for our user’s recipes, it also believes that none of the data is particularly accurate. Our platform questions the value behind these numbers that are too easy to tweak. Being a cultural platform, we would like to approach healthy eating not as a nutrition website would do, but a platform that is devoted to bringing delicious authentic and unaltered cultural cuisines from around the world. Recipes that are appreciated not because they are too low in calory or less fatty, but because they are original, authentic, and healthy and it has been viewed as so for millennials.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isAccount">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            How Do I Become A Host on Culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Becoming a host on Culturesquare.com is easy. Just go through the following simple steps and you are on your way to hosting events on Culturesquare.com:
                                    <ul class="ml-5" style="list-style:disc">
                                        <li>First sign up to become registered user</li>
                                        <li>Fill in your personal information such as your name, and nationality</li>
                                        <li>Pick your area of expertise and start posting</li>
                                    </ul>
                                    First, you will need to register as an active User and fill in your personal information such as your name and nationality. After the initial registration process, you will have the option to either host events, become a language instructor, create a language club, post a local dish recipe, sell or become a guest to events hosted by others on the platform.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            How Do I Become A Host on Culturesquare.com?
                        </b-card-header>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    As a host you can earn income doing the following
                                    <ul class="ml-5 " style="list-style:auto">
                                        <li>Host someone at your house for a week or less to mentor them about your culture</li>
                                        <li>Host cultural events that educate tourists visiting your city or your neighborhood</li>
                                        <li>Teach your local language to students around the world interested in your culture</li>
                                        <li>Run a language club and start charging monthly membership</li>
                                        <li>Teach about traditional cuisine and spices</li>
                                        <li>Create a store where you sell unique items about your culture</li>
                                    </ul>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            Do I have To Pay To Maintain An Active User Account?
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    No. You do not need to pay to maintain an active account with Culturesquare.com. the platform is free to register. However, note that if you are hosting a paid service or event, Culturesquare.com will take a commission made up of a service and transaction fees. Please, find below the fee’s details.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            How To Operate As A Business Account?
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    In order to operate as a business, our registered members would be prompted to open a Stripe Payment account also called wallet, with Stripe Payment Service. Culturesquare.com has partnered with Stripe Payment Service Inc. to process securely all transaction occurring on its platform. In order to get paid, registered users will be prompted to enter certain information on their assigned Stripe account, such as bank details, name and address. you will need to have a valid business license or proof of registration to show that you are legally allowed to operate a business in your specific country.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            How Many Business Documents Should I Upload?
                        </b-card-header>
                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    One good verification document would be enough as long as the name on it and the address match the name and the address of the point of contact provided during registration.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            What Is Considered A Valid Business Document?
                        </b-card-header>
                        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Any government issued business ID card, business license, a tax EIN document, business bank statement will be considered valid. Note that these requirements and documents may differ from country to country.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-7 header-tag="header" class="p-3" role="tab">
                            Can I Use The Same Account For store.culturequare.com?
                        </b-card-header>
                        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Yes all account for both event and store side (customer only) are in sync, you do not need to create another account unless if you want to become a vendor on store.culturesquare.com then you will need to create a vendor account.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-8 header-tag="header" class="p-3" role="tab">
                            How Can I Delete My Account?
                        </b-card-header>
                        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    In order for the Culturesquare.com member to delete their account, they will have to reach out to <span class="culture-primary">support@culturesquare.com</span>. Note that a deleted account may take 90 days for all its related contents to completely phase out from the system.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-9 header-tag="header" class="p-3" role="tab">
                            Can I restore my deleted account?
                        </b-card-header>
                        <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    It is more likely to restore an account deleted within less than 90 days, but it is not guaranteed. You may be asked to create a completely different account by our support team. To avoid loosing contents, make sure that the decision to delete an account is a well thought-through move since it may affect your contents.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="accordion" role="tablist" v-if="isSubscription">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            What Is Culturesquare.com Subscription Service
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    On a personal or organizational level, we have those festive moments which we strongly feel need to be commemorated. At Culturesquare.com we bring the world to your event. As subscribed member, you will have the opportunity to pick menus from different cultures around the world and sample them before your events take place as well as given the choices to have a cultural performance.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            How does Culturesquare.com subscription service work?
                        </b-card-header>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    <ul class="ml-5 mb-3" style="list-style:auto">
                                        <li>Create an account</li>
                                        <li>Click on event</li>
                                        <li>Click on subscribe</li>
                                        <li>Choose your plan</li>
                                        <li>Enter your credentials and reason for singing up</li>
                                        <li>Describe you event</li>
                                        <li>Click subscribe </li>
                                    </ul>
                                    One of our events consultants will reach out to you based on the information you provided to develop an event strategy which fits your budget and cultural experience preferences
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            What Are The Three Subscription Plans?
                        </b-card-header>
                        <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    The three subscription plans are
                                    <ul class="ml-5 mb-3" style="list-style:auto">
                                        <li><b>Individual:</b> Good for 1- 5 people event</li>
                                        <li><b>Professional:</b> Good for a small company with less than 25 employees</li>
                                        <li><b>Enterprise:</b> Good for medium-size companies or a public event with more than 25 plus employees.</li>
                                    </ul>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            How does Subscription Payment Work?
                        </b-card-header>
                        <b-collapse id="accordion-4" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Given the amount of planning that goes into organizing an event and the cost constraints, Culturesquare.com charges a twelve-month prorated premium for any event scheduled in less than 10 months. If the event is scheduled to occur in 10 month or more, a monthly subscription fee will be deducted each month until the scheduled month
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            How is Subscription Renewed?
                        </b-card-header>
                        <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    All subscriptions are renewed automatically each year unless you contact our support team at: <span class="culture-primary">support@culturesquare.com</span>
                                    to unsubscribe. Note that the credit card on file should be up to date for the subscription to be maintained. An expired card may result in your subscription to be suspended indefinitely.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            How Can I Unsubscribe From The Platform?
                        </b-card-header>
                        <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    No renewal or not updating the card on file can result in your account being suspended. However, if you want to unsubscribe, please, contact us at: <span class="culture-primary">support@culturesquare.com</span>
                                    and we will unsubscribe you and delete all account payments associated with your profile
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                </div>
                <div class="accordion" role="tablist" v-if="isPayment">
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-3" role="tab">
                            What Form of Payment Can I use?
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Culture Square will effect most of its transactions using major global currencies such as the <b>US Dollar</b> and other global currencies such as Euro, Chinese yuan, Japanese Yen and Canadian Dollar. Please, do not hesitate to contact our Support Team by filling the contact us form: <router-link class="culture-primary" to="/contact-us"> https://www.culturesquare.com/contact-us. </router-link> Our team will follow up with you to help you get started, unless there are regulatory hurdles to overcome which will be communicated to you.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-3" role="tab">
                            Can I Send In Paper Check?
                        </b-card-header>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    <b>Culturesquare.com</b> will accepts, Visa, MasterCard, Discovery and Checks or money orders denominated in U.S. Dollars as payment for paid events as long as they can be mailed to us within 7 business days before the event takes place. We also take any form of payment as donation only. <br> <br>
                                    To mail a check please address it to: Culturesquare.com, Memo: write the reason for sending in the check, and mail it to 3010 Greengarden Blvd Erie Pa 16508.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-3" role="tab">
                            I Host Paid Event, How do I get Paid?
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    As an independent contractor, you get paid what you earn. Again, our platform is built to encourage generosity. If you decide to host your event for free, ask for a gift contribution or even charge, you will get exactly what you asked for minus the following fees:
                                    <ul class="ml-5 font-weight-bold" style="list-style:auto;font-style:italics">
                                        <li>Service fee: 9% of total cart</li>
                                        <li>Transaction fee by Stripe: 2% plus 0.30 cent flat fee of total cart</li>
                                        <li>Disbursement fee: 0.50 cent per withdrawal request by Stripe Payment Service INC.</li>
                                    </ul>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-3" role="tab">
                            Why Is The User Who Is Hosting For Free Not Paid By Culture Square?
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    We will run sweepstakes programs to encourage and promote the users’ generosity. Again, every user is considered as an independent contractor, and it is up to them to decide if their events will be priced or hosted for free. We at Culture Square have little or no say on that decision making process. Our core value is to create the Human Moment between cultures. We have a firm belief that when monetary transactions are involved between the host and the guest, the true essence of hospitality is diluted due to a feeling of entitlement and high expectations that engulfs the Guest. On the Host’s side, there is a burden of duty to deliver, which creates a tense atmosphere. However, when someone opens their space to host a Guest for a few hours out of sheer power of spreading kindness it becomes a privilege to the guest, and the Human Moment is created. Again, our stance is that you are free to create any kind of event, paid or free. And if it is paid, we will transfer every payment received minus the transaction costs as calculated above.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-3" role="tab">
                            Does It Cost To Get Services, Products, Or Solutions From A Service Provider?
                        </b-card-header>
                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    As stated in the previous paragraph, most Service Providers charge their services or products. Thus, the answer is yes, however, Users will be able to tell if a service is free or paid as there will be a cost tag. All charges will show up on the Culture Square Platform. All bookings made on the Culture Square will exhibit the final charges including required fees such as taxes and shipping fees.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-6 header-tag="header" class="p-3" role="tab">
                            Can A Host Receive Direct Payment From Guests (Attendees)?
                        </b-card-header>
                        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    No. Culturesquare.com Terms and Conditions prohibits its Users to charge fees or issue other forms of payments outside the Culturesquare.com other than the total fee collected during the time of booking on the platform. If User (host or guest) realizes that they undercharge or overcharge the service, we advise that they reach out to <span class="culture-primary">support@culturesquare.com</span>
                                    and we will make sure that the charges are adjusted.
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header v-b-toggle.accordion-7 header-tag="header" class="p-3" role="tab">
                            Can A Host Or Guest Receive Any Gift Or Monetary Contribution called tips?
                        </b-card-header>
                        <b-collapse id="accordion-7" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Yes. An exchange of gifts and any contribution be it monetary (a tip)) is encouraged between Host and Guest as long as it does not infringe the Culturesquare.com ’s Terms and Conditions on booking and payment of services and products
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                </div>
            </b-col>
        </b-row>
    </b-container>
    <Footer />

</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
export default {
    name: "faq",
    data: function () {
        return {
            headerText: "Have a",
            headerTextEmpahasis: "Question?",
            subText: "Find answers to frequently asked questions",
            fadedText: "faq",
            isGeneral: true,
            isRefunds: false,
            isLanguage: false,
            isEvents: false,
            isRecipe: false,
            isInstructor: false,
            isAccount: false,
            isSubscription: false,
            isPayment: false,
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Footer,
        Activation
    },
    methods: {
        handleGeneral() {
            this.isGeneral = true;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleRefunds() {
            this.isGeneral = false;
            this.isRefunds = true;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleLang() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = true;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleEvent() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = true;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleRecipe() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = true;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleInstructor() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = true;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleAccount() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = true;
            this.isSubscription = false;
            this.isPayment = false
        },
        handleSub() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = true;
            this.isPayment = false
        },
        handlePayment() {
            this.isGeneral = false;
            this.isRefunds = false;
            this.isLanguage = false;
            this.isEvents = false;
            this.isRecipe = false;
            this.isInstructor = false;
            this.isAccount = false;
            this.isSubscription = false;
            this.isPayment = true
        }
    }
}
</script>

<style lang="scss" scoped>
.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}

.card-header {
    text-align: left !important;
    cursor: pointer;
    border-bottom: none !important
}

.card {
    border: none !important;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
}
.card:hover{
    border:1px solid #F7B131 !important
}
@media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    .card-body {
        background: #000;
        color: #fff
    }
}
</style>
